import { createContext } from 'react'
import { SidebarContentLinkListContextProps } from '@/presentation/common/store/apiContext/types.ts'

export const SidebarContentLinkListContext = createContext<SidebarContentLinkListContextProps>({
  setCurrentLinkNode : () => void 0,
  parentLinkNode     : null,
})
